// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@awc/Overrides/Widgets/OrderConfirmation/OrderConfirmationHeader";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

headerStyles.continueButton = {
    variant: "tertiary",
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};
headerStyles.printButton = {
    variant: "primary",
    css: css`
        ${xScreen("lte", "sm")} {
            display: none;
        }
    `,
};
headerStyles.addToListButton = {
    variant: "primary",
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};
headerStyles.buttonGridItem = {
    width: 12,
    css: css`
        column-gap: 16px;
        flex-wrap: wrap;
        justify-content: flex-end;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            row-gap: 12px;
        }
    `,
};
